module.exports = __webpack_public_path__ + "media/images/front/icons/new-9e5217d13a2e85d59242c516209b4201.png";